<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="z-title z-title--small">
          Falar com o Quero Pago
        </div>

        <p class="z-text spacer-bottom-l">
          Temos uma equipe especial para cuidar de você. Por onde você gostaria de conversar?
        </p>

        <div class="cards-wrapper">
          <action-card
            title="Whatsapp"
            url="https://api.whatsapp.com/send?phone=558002917878"
            new-tab
            icon="whatsapp"
            icon-prefix="fab"
            @click.native="clickedWhatsapp()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cards-wrapper {
  display: grid;
  grid-column-gap: var(--space-medium);
  grid-row-gap: var(--space-medium);
  grid-template-columns: 1fr 1fr;

  @media (min-width: $screen-md-min) {
    grid-column-gap: var(--space-extra-large);
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.highlight-text {
  font-size: rem(19);
  font-weight: var(--font-weight-bold);
  line-height: rem(23);
  margin-bottom: var(--space-large);
  margin-top: var(--space-large);
  text-align: center;

  @media (min-width: $screen-sm-min) {
    margin-bottom: 0;
    margin-top: var(--space-medium);
    text-align: left;
  }
}
</style>

<script>
import ActionCard from 'components/action-card';
import Breadcrumb from 'components/breadcrumb';
import { mapState } from 'vuex';

export default {
  components: {
    ActionCard,
    Breadcrumb,
  },
  computed: {
    ...mapState([
      'student',
    ]),
  },
  methods: {
    clickedWhatsapp() {
      this.$tracker.logEvent('[contacts] Clicked Whatsapp');
    },
  },
  mounted() {
    this.$tracker.logEvent('Viewed Contacts Page');
  },
};
</script>
